import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return (planzone) =>
    present(
      repository
        .getAccessRestrictions(planzone)
        .then((restrictions) => ({ planzone, restrictions }))
        .catch(() => Promise.reject(planzone)),
    );
}

export type { Interactor };

export { createInteractor };
